import React, { useCallback, useContext, useMemo } from 'react';
import classNames from 'classnames';
import { Params } from 'react-router-dom';
import useQueryParams from 'hooks/useQueryParams';
import { Checkbox } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import ContactCard from './components/ContactCard';
import { Contact } from 'models/Contact';
import { SortingButton } from 'router/subrouters/DataRoom/components/SortingButton';
import ContactsContext from '../../../../providers/Contacts/Contacts.context';
import { SORTING_VALUES } from '../ContactsTable/components/ManagePeopleTableCells/data';

import './ContactsCards.styles.scss';
import './ContactsCards.styles.responsive.scss';

const sortName = SORTING_VALUES.firstName;

type ContactsCardsProps = {
  className?: string;
  isLoading?: boolean;
  contacts: Contact[];
  handleEdit: (contact: Contact) => void;
  handleDelete: (id: string) => void;
};

const ContactsCards: React.FC<ContactsCardsProps> = (props) => {
  const { className, contacts, handleEdit, handleDelete } = props;

  const classes = classNames('contacts-cards', className);

  const { t } = useTranslation();
  const {
    params: { sort },
    setQueryParam,
  } = useQueryParams<Params>();

  const { selected, isAllSelected, selectAll, removeAll, updateSelected } =
    useContext(ContactsContext);

  const hasSelectedItems = useMemo(
    () => !!selected?.length,
    [selected?.length],
  );

  const updateSort = useCallback(
    () => setQueryParam('sort', sort === sortName ? `-${sortName}` : sortName),
    [sort, setQueryParam],
  );

  return (
    <div className={classes}>
      <div className="contacts-cards__select-all">
        <Checkbox
          label={t('selectAll')}
          checked={isAllSelected}
          onChange={isAllSelected ? removeAll : selectAll}
        />

        <span>
          <SortingButton
            content={t('aToZ')}
            sortingValue={sortName}
            sort={sort}
            updateSort={updateSort}
          />
        </span>
      </div>

      {contacts.map((contact) => (
        <ContactCard
          key={contact._id}
          contact={contact}
          isSelected={selected.some(({ _id }) => _id === contact._id)}
          handleEdit={() => handleEdit(contact)}
          handleDelete={() => handleDelete(contact._id)}
          handleOnSelect={() => updateSelected(contact)}
          handleOnClick={() => {
            if (hasSelectedItems) {
              updateSelected(contact);
            } else handleEdit(contact);
          }}
        />
      ))}
    </div>
  );
};

export default ContactsCards;
